/**
 * 11 groups of 4 digits, the common display form printed on the DANFE. Spelled out
 * instead of built with `Array(11).fill(...).join(...)`: a top-level call cannot be
 * proven pure by consumer bundlers and would pin this module into their output.
 */
export const PATTERN = "0000 0000 0000 0000 0000 0000 0000 0000 0000 0000 0000";
